import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { $ } from 'jquery';
import { MessageService } from 'primeng/api';
import { ActiveCountries } from '../Models/ActiveClasses';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { ImportPnrAgencyDetails, ImportPnrfareDetailsProperties, ImportPnrPassengerDetailsProperties, ImportPnrDetails, ImportPnrSectorInfoProperties, ImportPnrTaxDetailsProperties, ImportPNRIssuanceResponse } from '../Models/ImportPnrProperties';
import { OfflineBookingListOnlineDetailsOrOffline } from '../Models/OfflineBookingProperties';
import { buttonpropertiesforticketissueance, TicketDataRequest, TicketIssuanceProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { ImportPnrService } from '../Services/import-pnr.service';
import { OfflineRequestService } from '../Services/offline-request.service';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { Observable, of } from 'rxjs';
import { ViewChild, TemplateRef } from '@angular/core';
import { UsersService } from '../Services/users.service';

@Component({
  selector: 'app-data-fetched-from-offline',
  templateUrl: './data-fetched-from-offline.component.html',
  styleUrls: ['./data-fetched-from-offline.component.css']
})
export class DataFetchedFromOfflineComponent {
  selectedPcc: string = '';
  pccList$: Observable<Supplier_OficeID[]>;
  importPNRPassengerinfo: BookingPassengerInfoProperties[] = [];
  importPNRfaredetails = new ImportPnrfareDetailsProperties();
  importPNR = new TicketIssuanceProperties();
  importPNRSectorinfodisplay: SectorInformationProperties[] = [];
  /*  importPNRagencydetails=new ImportPnrAgencyDetails();*/
  importPNRid: number;
  importpnrreturndata = new ImportPNRIssuanceResponse();
  countryList: ActiveCountries[];
  adultfareId: boolean = false;
  childfareId: boolean = false;
  infantfareId: boolean = false;
  emailAddress: string = "";
  mobileContact: string = "";
  bookingID: number;
  offlineIdRequestFromOfflineList: number = 0;
  offlineTempId: number = 0;
  requestTypeIdOffline: string = "";
  onlineRequestfromOfflineAgencyId: string = "";
  offlineRequestNoRight: string;
  fromroute: string = "";
  checkbuttonhideshow = new buttonpropertiesforticketissueance();

  offlineOrOnlineRequestList = new OfflineBookingListOnlineDetailsOrOffline();
  isOfflineParked: boolean;
  totalAmount: number = 0;
  serviceChargesPerPassenger: number = 0;
  totalSumAmount: number = 0;
  tktPnrRight = new TicketPnrRights();
  showServiceChargesModalForBranch: boolean = false;
  importForAgencyId: string = localStorage.getItem("ImportForAgencyId") || '';
  loader: boolean = false;
  modalTitle: string = '';
  modalMessage: string = '';
  showPostInvoiceAfterIssuanceForAccounts: boolean = false;
  navMenu: any = null;
  isPostingInvoice: boolean = false;
  @ViewChild('customerLimitExceededModal', { static: false })
  customerLimitExceededModal!: TemplateRef<any>;

  constructor(private service: OfflineRequestService, private messageservice: MessageService, private userService: PassengerInfoService, private model: NgbModal, private termsmodel: NgbModal, private router: Router, private importpnrservice: ImportPnrService, private flightService: FlightSearchService, private ticketIssuanceService: TicketIssuanceService, private userService2: UsersService) {

  }
  ngOnInit() {

    this.loader = true;
    try {
      if (localStorage.getItem("isOfflineParked") != null || localStorage.getItem("isOfflineParked") != undefined) {
        if (localStorage.getItem("isOfflineParked") == "True") {
          this.isOfflineParked = true;
        }
        else if (localStorage.getItem("isOfflineParked") == "False") {
          this.isOfflineParked = false;
        }
      }


      this.importPNRid = Number(localStorage.getItem("importPNRID"));
      this.fromroute = localStorage.getItem("fromroutePageNoright");
      if (this.importForAgencyId.includes("AG01B")) {
        this.showServiceChargesModalForBranch = true;
      }
    }
    catch (e) {

    }

    this.getCountries();
    this.loadImportPnrData();
    //this.importPNRid = 7;
    // if (this.importPNRid != null && this.importPNRid != undefined && this.importPNRid != 0) {
    //   this.importpnrservice.CheckTktPnrRightsAgainstImportPNR(localStorage.getItem("AgencyId"), localStorage.getItem("UserId"), this.importPNRid).subscribe((data2) => {
    //     this.tktPnrRight = data2;
    //     this.loadImportPnrData();
    //   });
    //   this.ticketIssuanceService.CheckTktPnrRightsAgainstBooking(localStorage.getItem("AgencyId"), localStorage.getItem("UserId"), this.importPNRid).subscribe((data2) => {
    //     this.tktPnrRight = data2;
    //     this.loadImportPnrData();
    //   });
    // }
    // else {
    //   document.getElementById("buttonissue1").classList.add("hiddenbuttonissue");
    // }
    this.buttonagreed = true;
  }
  //loadImportPnrData() {
  //  let agencyId = localStorage.getItem("AgencyId");
  //  let userId = Number(localStorage.getItem("UserId"));
  //  this.importpnrservice.GetPNRByID(this.importPNRid, agencyId, userId).subscribe(data => {
  //    this.importPNRSectorinfodisplay=[];
  //    console.log(data);
  //    this.importPNR = data;


  //    if (this.importPNR.importPnrAgencyDetailsInfo.status == true) {
  //      document.getElementById("buttonissue").classList.add("hiddenbuttonissue");
  //      document.getElementById("buttonissue1").classList.add("hiddenbuttonissue");
  //    }
  //    this.importPNRPassengerinfo = this.importPNR.importPassengerPnrInfo;
  //    for (let i = 0; i < this.importPNRPassengerinfo.length; i++) {
  //      this.importPNRPassengerinfo[i].passportValidFrom =this.importPNRPassengerinfo[i].passportValidFrom.split("T")[0];
  //      this.importPNRPassengerinfo[i].passportValidTo = this.importPNRPassengerinfo[i].passportValidTo.split("T")[0];
  //    }
  //    this.importPNRfaredetails = this.importPNR.fareDetails;

  //    if (this.importPNRfaredetails.childfare.paxcount > 0) {
  //      document.getElementById("childid").classList.remove("hiddenclasschild");
  //    }
  //    if (this.importPNRfaredetails.infantfare.paxcount > 0) {
  //      document.getElementById("infantid").classList.remove("hiddenclassinfant");
  //    }
  //    this.importPNRagencydetails = this.importPNR.importPnrAgencyDetailsInfo;
  //    let psId = this.importPNRPassengerinfo[0].passengerID;
  //    for (let j = 0; j < this.importPNR.sectorInformation.length; j++) {
  //      if (this.importPNR.sectorInformation[j].importPNR_PassengerID == psId) {
  //        this.importPNRSectorinfodisplay.push(this.importPNR.sectorInformation[j]);
  //      }
  //    }
  //  });

  //}
  loadImportPnrData() {
    let ticketobj = new TicketDataRequest();
    ticketobj.agencyId = localStorage.getItem("AgencyId");
    ticketobj.userId = Number(localStorage.getItem("UserId"));
    ticketobj.bookingID = Number(localStorage.getItem("importPNRID"));


    this.importpnrservice.getBookingInfo(ticketobj).subscribe((data) => {
      this.importPNR = data;

      this.importPNRfaredetails.adultfare.paxcount = 0;
      this.importPNRfaredetails.childfare.paxcount = 0;
      this.importPNRfaredetails.infantfare.paxcount = 0;
      this.totalAmount = 0;
      this.importPNRSectorinfodisplay = [];
      /*this.supplierMsg = this.bookingAllData$.pnrLocalMsg;*/
      //this.importPNRSectorinfodisplay = this.importPNR.sectorInformation;

      for (let u = 0; u < this.importPNR.bookingInfo.bookingPassengerInfoProperties.length; u++) {



        this.totalAmount += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].netFromCustomer;
        this.totalSumAmount += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].netFromCustomer;
        this.serviceChargesPerPassenger += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].serviceCharges;
        //this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].paxdob = this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].paxdob
        this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].firstNameShow = this.moveLastWordToStart(this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].firstName);
        if (this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].passengerType == 1) {
          this.importPNRfaredetails.adultfare.basecurrency = this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseCurrency;
          this.importPNRfaredetails.adultfare.basefare += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseFare;
          this.importPNRfaredetails.adultfare.discount += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].discount;
          this.importPNRfaredetails.adultfare.netTotal += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].netFromCustomer;
          this.importPNRfaredetails.adultfare.paxtype = "Adult";
          this.importPNRfaredetails.adultfare.paxcount = this.importPNRfaredetails.adultfare.paxcount + 1;
          this.importPNRfaredetails.adultfare.serviceCharges += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].serviceCharges;
          this.importPNRfaredetails.adultfare.totaltaxes += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].totalTaxes;
        }
        if (this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].passengerType == 2) {
          this.importPNRfaredetails.childfare.basecurrency = this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseCurrency;
          this.importPNRfaredetails.childfare.basefare += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseFare;
          this.importPNRfaredetails.childfare.discount += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].discount;
          this.importPNRfaredetails.childfare.netTotal += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].netFromCustomer;
          this.importPNRfaredetails.childfare.paxtype = "Child";
          this.importPNRfaredetails.childfare.paxcount = this.importPNRfaredetails.childfare.paxcount + 1;
          this.importPNRfaredetails.childfare.serviceCharges += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].serviceCharges;
          this.importPNRfaredetails.childfare.totaltaxes += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].totalTaxes;
        }
        if (this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].passengerType == 3) {
          this.importPNRfaredetails.infantfare.basecurrency = this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseCurrency;
          this.importPNRfaredetails.infantfare.basefare += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].baseFare;
          this.importPNRfaredetails.infantfare.discount += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].discount;
          this.importPNRfaredetails.infantfare.netTotal += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].netFromCustomer;
          this.importPNRfaredetails.infantfare.paxtype = "INFT";
          this.importPNRfaredetails.infantfare.paxcount = this.importPNRfaredetails.infantfare.paxcount + 1;
          this.importPNRfaredetails.infantfare.serviceCharges += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].serviceCharges;
          this.importPNRfaredetails.infantfare.totaltaxes += this.importPNR.bookingInfo.bookingPassengerInfoProperties[u].totalTaxes;
        }

      }
      this.loader = false;
      if (this.isOfflineParked == true) {
        this.importpnrservice.getImportPNRrequestId(this.importPNRid).subscribe((data) => {
          console.log(data);
          if (data.requestTypeName == "Online Import PNR Ticket Request") {
            //if (this.tktPnrRight.issueTicket) {
            //  this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            //  this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            //  this.offlinetoOnline.TicketIssueReqFromOffline = true;
            //  this.offlinetoOnline.OfflineId = Number(data.offlineImportId);
            //}
            //else {
            //  this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
            //  this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
            //  this.offlinetoOnline.TicketIssueReqFromOffline = true;
            //  this.offlinetoOnline.OfflineId = Number(data.offlineImportId);
            //}
            this.offlineIdRequestFromOfflineList = Number(data.offlineImportId);
          }

        });
        //if (this.tktPnrRight.issueTicket == false) {
        //  document.getElementById("buttonissue").classList.add("hiddenbuttonissue");
        //}
      }
      this.importPNRPassengerinfo = this.importPNR.bookingInfo.bookingPassengerInfoProperties;
      //for (let i = 0; i < this.importPNRPassengerinfo.length; i++) {
      //  if (this.importPNRPassengerinfo[i].passportValidFrom != null && !this.importPNRPassengerinfo[i].passportValidFrom != undefined
      //    ) {
      //    this.importPNRPassengerinfo[i].passportValidFrom = this.importPNRPassengerinfo[i].passportValidFrom.split("T")[0];

      //  }
      //  else {
      //    this.importPNRPassengerinfo[i].passportValidFrom = null;
      //  }
      //  if (this.importPNRPassengerinfo[i].passportValidTo != null && !this.importPNRPassengerinfo[i].passportValidTo.includes("0001")
      //    && !this.importPNRPassengerinfo[i].passportValidTo=="0001") {
      //    this.importPNRPassengerinfo[i].passportValidTo = this.importPNRPassengerinfo[i].passportValidTo.split("T")[0];

      //  }
      //  else {
      //    this.importPNRPassengerinfo[i].passportValidTo = null;
      //  }
      //}//Izza
      /*   this.importPNRfaredetails = this.importPNR.fareDetails;*/
      if (this.importPNRfaredetails.adultfare != null && this.importPNRfaredetails.adultfare != undefined) {
        this.adultfareId = true;
      }
      if (this.importPNRfaredetails.childfare != null && this.importPNRfaredetails.childfare != undefined) {
        if ((this.importPNRfaredetails.childfare.basefare != null && this.importPNRfaredetails.childfare.basefare != undefined && this.importPNRfaredetails.childfare.basefare > 0) ||
          (this.importPNRfaredetails.childfare.totaltaxes != null && this.importPNRfaredetails.childfare.totaltaxes != undefined && this.importPNRfaredetails.childfare.totaltaxes > 0)) {
          this.childfareId = true;
        }

      }
      if (this.importPNRfaredetails.infantfare != null && this.importPNRfaredetails.infantfare != undefined) {
        if ((this.importPNRfaredetails.infantfare.basefare != null && this.importPNRfaredetails.infantfare.basefare != undefined && this.importPNRfaredetails.infantfare.basefare > 0) ||
          (this.importPNRfaredetails.infantfare.totaltaxes != null && this.importPNRfaredetails.infantfare.totaltaxes != undefined && this.importPNRfaredetails.infantfare.totaltaxes > 0)) {
          this.infantfareId = true;

        }
      }
      //if (this.importPNRfaredetails.childfare.paxcount > 0) {
      //  document.getElementById("childid").classList.remove("hiddenclasschild");
      //}
      //if (this.importPNRfaredetails.infantfare.paxcount > 0) {
      //  document.getElementById("infantid").classList.remove("hiddenclassinfant");
      //}
      /*      this.importPNRagencydetails = this.importPNR.importPnrAgencyDetailsInfo;*/
      let psId = this.importPNRPassengerinfo[0].passengerID;
      for (let j = 0; j < this.importPNR.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length; j++) {

        this.importPNRSectorinfodisplay.push(this.importPNR.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[j]);
        // }
      }

      // After Getting the Booking Data Check if its status is Ticketed or Not
      this.userService2.GetUsersNavMenu(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
        //////console.log (data);
        // this.navMenu = data;

        // data.reportUserRights.forEach(x => {
        //   console.log(`'${x.reportTypeName}'`, x.status);
        // });

        const postInvoiceRight = data.reportUserRights.find(
          x => x.reportTypeName === 'Post Invoice After Issuance'
        );

        if (
          postInvoiceRight.status && this.importPNR.bookingStatus == "Ticketed" && this.importPNR.bookingInfo.isImportPnr && !this.importPNR.bookingInfo.isInvoicePostedForImportPnr
        ) {
          // User has the right
          this.showPostInvoiceAfterIssuanceForAccounts = true;
        }

      });
    });


  }
  ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  DateofBirthPopUp(targetmodel) {
    this.model.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'sm',
    })
  }



  PassengerDetailsPopUp(targetmodel) {
    this.model.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  passengerDetailsPassport(obj, i) {
    console.log(obj);
    //return;
    if (this.dobValidation(this.importPNRPassengerinfo[i].paxdob, this.importPNRPassengerinfo[i].passengerType) == false) {
      document.getElementById(`Passportmessage${i}`).innerHTML = "Enter Valid Date Of Birth";
      setTimeout(function () {
        document.getElementById(`Passportmessage${i}`).innerHTML = "";
      }
        , 6000);
      return;
    }
    this.importPNRPassengerinfo[i].bookingInfoID = this.importPNRid;
    this.importpnrservice.UpdateImportPnrPassengerPassport(this.importPNRPassengerinfo[i]).subscribe((data) => {
      if (data == true) {
        document.getElementById(`Passportmessage${i}`).innerHTML = "Saved Succesfully";
        setTimeout(function () {
          document.getElementById(`Passportmessage${i}`).innerHTML = "";
        }
          , 6000);
        this.model.dismissAll();
      }
      else {
        document.getElementById(`Passportmessage${i}`).innerHTML = "Not Saved!";
        setTimeout(function () {
          document.getElementById(`Passportmessage${i}`).innerHTML = "";
        }
          , 6000);
      }
    })
  }

  agreed: boolean;
  buttonagreed: boolean;

  active() {
    if (this.agreed == true) {
      this.buttonagreed = false;
      document.getElementById("buttonissue").classList.remove("sendButton");
    }
    else {
      this.buttonagreed = true;
      document.getElementById("buttonissue").classList.add("sendButton");
    }
  }
  cancel() {
    if (this.fromroute == "OfflinePage") {
      this.offlineIdRequestFromOfflineList = 0;
      this.router.navigateByUrl('/offlineRequestList');
    }
    else if (this.fromroute == "ImportPNRPage") {
      this.router.navigateByUrl('/importPNRList');
      this.offlineIdRequestFromOfflineList = 0;
    }
    else if (this.fromroute == "OfflinePagemanger") {
      this.offlineIdRequestFromOfflineList = 0;
      this.router.navigateByUrl('/managerOfflineRequestList');
    }
    else if (this.fromroute == "BookingPage") {
      this.router.navigateByUrl('/bookingList');
      this.offlineIdRequestFromOfflineList = 0;
    }
    else if (this.fromroute == "B2BBackofficePage") {
      this.router.navigateByUrl('/B2BbackOffice');
      this.offlineIdRequestFromOfflineList = 0;
    }
    else if (this.fromroute == "BookingPageSearch") {
      this.router.navigateByUrl('/BookingSearch');
      this.offlineIdRequestFromOfflineList = 0;
    }
    else {
      this.router.navigateByUrl('/importPNRList');
      this.offlineIdRequestFromOfflineList = 0;
    }

  }
  //IssueTicket(model) {
  //  this.importPNR.importPnrAgencyDetailsInfo.importUser = Number(localStorage.getItem("UserId"));
  //  this.importPNR.parentHierarchy = (localStorage.getItem("ParentHierarchy"));
  //  this.importPNR.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
  //  this.importPNR.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
  //  for (let i = 0; i < this.importPNRPassengerinfo.length; i++) {
  //    if (this.importPNRPassengerinfo[i].paxdob == "" || this.importPNRPassengerinfo[i].paxdob == undefined || this.importPNRPassengerinfo[i].paxdob == null) {
  //      document.getElementById(`dateofbirthrequiredmessage${i}`).innerHTML = "Required DOB";
  //      setTimeout(function () {
  //        document.getElementById(`dateofbirthrequiredmessage${i}`).innerHTML = "";
  //      }
  //        , 6000);
  //      return;
  //    }
  //    if (this.importPNRPassengerinfo[i].passportValidFrom == "" || this.importPNRPassengerinfo[i].passportValidFrom == undefined || this.importPNRPassengerinfo[i].passportValidFrom == null ||
  //      this.importPNRPassengerinfo[i].passportValidTo == "" || this.importPNRPassengerinfo[i].passportValidTo == undefined || this.importPNRPassengerinfo[i].passportValidTo == null ||
  //      this.importPNRPassengerinfo[i].paxNationality == "" || this.importPNRPassengerinfo[i].paxNationality == undefined || this.importPNRPassengerinfo[i].paxNationality == null ||
  //      this.importPNRPassengerinfo[i].passportNumber == "" || this.importPNRPassengerinfo[i].passportNumber == undefined || this.importPNRPassengerinfo[i].passportNumber == null) {
  //      document.getElementById(`passportrequiredmessage${i}`).innerHTML = "Required Passport Details";
  //      setTimeout(function () {
  //        document.getElementById(`passportrequiredmessage${i}`).innerHTML = "";
  //      }
  //        , 6000);
  //      return;
  //    }
  //  }
  //  document.getElementById("loaderissue").classList.remove("loaders");
  //  this.importpnrservice.IssueGalileoFlight(this.importPNR).subscribe((data) => {
  //    this.importpnrreturndata = data;
  //    if (data.isIssued == true) {
  //      this.importPNRid = data.importPNRID;
  //      this.loadImportPnrData();
  //      document.getElementById("loaderissue").classList.add("loaders");
  //    }
  //    else {
  //      if (data.isPriceChanged) {
  //        this.importPNR.alreadyPriced = true;
  //        this.importPNR.airPricingSolution = data.airPricingSolution;
  //        this.model.open(model, { centered: true });
  //      }

  //      document.getElementById("issueerror").innerHTML = data.errorMsg;
  //      document.getElementById("loaderissue").classList.add("loaders");
  //    }
  //  })
  //}
  passengerDetailsDob(obj, i) {
    //console.log(obj);
    // return;
    //if (this.dobValidation(this.importPNRPassengerinfo[i].paxdob, this.importPNRPassengerinfo[i].passengerType) == false) {
    //  document.getElementById(`Passportmessagedob${i}`).innerHTML = "Enter Valid Date Of Birth";
    //  setTimeout(function () {
    //    document.getElementById(`Passportmessagedob${i}`).innerHTML = "";
    //  }
    //    , 6000);
    //  return;
    //}
    //this.importpnrservice.UpdateImportPnrPassengerDOB(obj).subscribe((data) => {
    //  if (data == true) {
    //    document.getElementById(`Passportmessagedob${i}`).innerHTML = "Saved Succesfully";
    //    setTimeout(function () {
    //      document.getElementById(`Passportmessagedob${i}`).innerHTML = "";
    //    }
    //      , 6000);
    //    this.model.dismissAll();
    //  }
    //  else {
    //    document.getElementById(`Passportmessagedob${i}`).innerHTML = "Not Saved!";
    //    setTimeout(function () {
    //      document.getElementById(`Passportmessagedob${i}`).innerHTML = "";
    //    }
    //      , 6000);
    //  }
    //})
  }

  PostInvoiceForTicketsIssuedOfflineImportedThroughImportPnr() {

    if (this.isPostingInvoice) {
      return;
    }

    this.isPostingInvoice = true;

    this.ticketIssuanceService
      .GetTicketBalanceLimitForTicketsIssuedOfflineImportedThroughImportPnr(this.importPNR.bookingInfo)
      .subscribe(result => {

        if (result) {

          // Balance is OK
          this.postInvoice();

        } else {

          this.isPostingInvoice = false;

          this.openCustomerLimitExceededModal();

        }

      }, () => {
        this.isPostingInvoice = false;
      });

  }
  private postInvoice() {
    if (this.importForAgencyId.includes("AG01B"))
    {
      for (let i = 0; i < this.importPNR.bookingInfo.bookingPassengerInfoProperties.length; i++) {

        this.importPNR.bookingInfo.bookingPassengerInfoProperties[i].serviceCharges = this.serviceChargesPerPassenger;
        this.importPNR.bookingInfo.finalBuyerID = this.importForAgencyId;
      }
      this.ticketIssuanceService
        .PostInvoiceForBranchesStaff(this.importPNR.bookingInfo)
        .subscribe(data => {

          this.isPostingInvoice = false;

          if (data.isSaved) {

            document.getElementById("invoice-msg").innerHTML =
              "Invoice Posted Successfully";

            this.showPostInvoiceAfterIssuanceForAccounts = false;

          } else {

            document.getElementById("invoice-msg").innerHTML =
              data.errorInfo;
          }

        }, () => {
          this.isPostingInvoice = false;
        });
    }
    else {
      this.ticketIssuanceService
        .PostInvoiceForTicketsIssuedOfflineImportedThroughImportPnr(this.importPNR.bookingInfo)
        .subscribe(data => {

          this.isPostingInvoice = false;

          if (data) {

            document.getElementById("invoice-msg").innerHTML =
              "Invoice Posted Successfully";

            this.showPostInvoiceAfterIssuanceForAccounts = false;

          } else {

            document.getElementById("invoice-msg").innerHTML =
              "Something went wrong while posting invoice";
          }

        }, () => {
          this.isPostingInvoice = false;
        });
    }
    

  }
  openCustomerLimitExceededModal() {

    this.model.open(this.customerLimitExceededModal, {
      centered: true,
      backdrop: 'static'
    }).result.then(result => {

      if (result === true) {

        this.isPostingInvoice = true;
        this.postInvoice();

      }

    }).catch(() => { });

  }
  openServiceChargesModel(targetmodel) {
    let result = this.importPNR.bookingInfo.bookingPassengerInfoProperties;

    this.model.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true, size: 'lg'
    })
  }
  moveLastWordToStart(text: string): string {
    let lastWord = "";
    let remainingWords = "";

    try {
      if (!text || text.trim() === "") {
        return text;
      }

      const words = text.trim().split(" ");

      if (words.length <= 1) {
        return text;
      }

      lastWord = words[words.length - 1];
      remainingWords = words.slice(0, -1).join(" ");
    } catch (error) {
      return text;
    }

    // Combine last word at the start
    return `${lastWord} ${remainingWords}`;
  }
  applyServiceCharges(modal: any) {
    const passengerCount = this.importPNR.bookingInfo.bookingPassengerInfoProperties.length || 0;

    const servicePerPax = Number(this.serviceChargesPerPassenger) || 0;
    const baseAmount = Number(this.totalAmount) || 0;
    const totalService = passengerCount * servicePerPax;

    this.totalSumAmount = baseAmount + totalService;
    modal.close();
  }
  dobDifference: number;
  isDOBVarified: boolean;
  dobValidation(dobvalue, pstypedob) {
    /*for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {*/
    /* var dobDatePax = document.getElementById(`dob_input${j}`) as HTMLInputElement;*/
    let currentDate: Date = new Date();
    let dob: Date = new Date(dobvalue);
    this.dobDifference = currentDate.getMonth() - dob.getMonth() +
      (12 * (currentDate.getFullYear() - dob.getFullYear()));

    if (this.dobDifference >= 144 && this.dobDifference < 1200 && pstypedob == 1) {
      this.isDOBVarified = true;
      // console.log("Adult Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference >= 24 && this.dobDifference < 144 && pstypedob == 2) {
      this.isDOBVarified = true;
      // console.log("Child Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference > 0 && this.dobDifference < 24 && pstypedob == 3) {
      //alert("Infant is Over Aged..Must be less than 2 years of age.");
      this.isDOBVarified = true;
      //console.log("Infant Age Varified...!" + this.dobDifference);
    }

    else if (this.dobDifference < 0) {
      //alert("Enter a valid date of birth.");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else if (this.dobDifference > 1200) {
      // alert("How can you live that long???");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else {
      //alert("Age not met to conditions!");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }

    /*    }*/

    return this.isDOBVarified;
  }
  importtermsncond(model) {
    this.termsmodel.open(model, { centered: true });
  }
  loadBaseDataByPNR(importPNRid) {
    try {
      this.loader = true;
      this.offlineOrOnlineRequestList.agencyId = localStorage.getItem("AgencyId");
      this.offlineOrOnlineRequestList.userId = Number(localStorage.getItem("UserId"));
      this.offlineOrOnlineRequestList.onlineBookingId = importPNRid;
      this.offlineOrOnlineRequestList.isTicketOnline = "True";
      this.offlineOrOnlineRequestList.isVoidOnline = "";
      this.offlineOrOnlineRequestList.isPnrCancelOnline = "";
      this.offlineOrOnlineRequestList.isRefund = "";
      this.offlineOrOnlineRequestList.ticketReRequest = false;
      this.importpnrservice.getOfflineBookingbyPNRAllData(this.offlineOrOnlineRequestList).subscribe((data1) => {
        console.log(data1);
        if (data1 == true) {
          this.loader = false;
          this.isOfflineParked = true;
          localStorage.removeItem("IsTicket");
          localStorage.setItem("OnlineBookingId", JSON.stringify(this.importPNRid));
          localStorage.setItem("IsTicket", "false");
          localStorage.setItem("TicketReRequest", "false");

          this.router.navigateByUrl('/offlineRequestList');
        }
        this.loader = false;

      });
    } catch (ex) { console.log(ex); }
  }


}
